export default __webpack_public_path__ + "static/media/screen6.9b92e309.png";